import React from 'react';
import './Header.css';

const Header = ({ connectionStatus }) => {
  const isConnected = connectionStatus === 1;
  return (
    <header className="app-header">
      <div className="app-header__brand">
        <span className="app-header__logo">📖</span>
        <h1 className="app-header__title">Gemara Notes</h1>
      </div>
      <div className={`app-header__status ${isConnected ? 'app-header__status--connected' : 'app-header__status--disconnected'}`}>
        <span className="app-header__status-dot" />
        {isConnected ? 'Connected' : 'Disconnected'}
      </div>
    </header>
  );
};

export default Header;
